module.exports = __webpack_public_path__ + "static/media/logo.fe4c007e.png";